module.exports = __webpack_public_path__ + "static/img/zijian2.01f4bf4e.png";